import { render, staticRenderFns } from "./AlertsView.vue?vue&type=template&id=452f4604&scoped=true"
import script from "./AlertsView.vue?vue&type=script&lang=js"
export * from "./AlertsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452f4604",
  null
  
)

export default component.exports